import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DeleteMaintenanceRecordService {

  httpClient = inject(HttpClient);
  constructor() { }

  deleteMaintenance(maintenanceId: number) {
    return this.httpClient.delete<void>(`${environment.apiServer}/Adjuster/Claim/DeleteMaintenanceRecord?maintenanceId=${maintenanceId}`);
  }
}
